import React, { useState } from 'react'
import passedIcon from "../assets/svg/State Icons 5.svg"
import partiallyPassedIcon from "../assets/svg/State Icons 6.svg"
import deductIcon from "../assets/svg/Canceled.svg"
import ligthImage from "../assets/svg/Rectangle 4197.svg"
import merrorImg1 from "../assets/svg/Rectangle 4197 (1).svg"
import merrorImg2 from "../assets/svg/Rectangle 4196.svg"
import equipmentImg1 from "../assets/svg/Frame 1618873039.svg"
import equipmentImg2 from "../assets/svg/Rectangle 4197 (3).svg"
import serviceImg from "../assets/svg/svgexport-11 (3).svg"
import serviceImg1 from "../assets/svg/Group 162605.svg"
import serviceImg2 from "../assets/svg/Group 162553.svg"
import vehicleImg from "../assets/svg/State Icons 3.svg"
import { Tune } from '@mui/icons-material'
import { Box, Checkbox, IconButton, Menu, MenuItem, Paper, Tab, Tabs } from '@mui/material'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { DataGrid } from '@mui/x-data-grid'
import { Modal } from 'react-bootstrap'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const DailyCheckVanProfile = () => {
      const [filterDate, setFilterDate] = useState("");
      const [submitChangeStatus, setSubmitChangeStatus] = useState([{
                  id:"1",
                  name:"Pending",
                  icon: passedIcon
                }])
      const [anchorEl, setAnchorEl] = useState(null);
      const open = Boolean(anchorEl);
      const statuses = [{title:"Passed", icon:passedIcon,id:"1"},{title:"Partially passed", icon:partiallyPassedIcon,id:"2"},{title:"Failed", icon:deductIcon,id:"3"}]
      const [tab, setTab] = useState(0);

  const columns = [
    { field: "date", headerName: "Check Date", flex: 0.9, minWidth: 120 },
    {
      field: "Name",
      headerName: "Driver Name",
      flex: 0.9,
      minWidth: 120,
      // renderCell: (params) => {
      //   const { name, imageUrl } = params.value;

      //   return (
      //     <div className="d-flex justify-content-center align-items-center h-100">
      //       <img
      //         src={imageUrl}
      //         alt={`${name} logo`}
      //         style={{
      //           width: 20,
      //           height: 20,
      //           objectFit: "cover",
      //         }}
      //       />
      //       <span className="ms-2">{name}</span>
      //     </div>
      //   );
      // },
    },
      {
              field: "status",
              headerName: "Status",
              flex: 0.9,
              minWidth: 120,
              // renderCell: (params) => (
              //   <div className="d-flex gap-2 align-items-center justify-content-center">
              //     <img
              //       src={
              //         params.row?.status?.image
              //           ? `${newImageUrl}${params.row.status.image}`
              //           : defaultImg
              //       }
              //       width={20}
              //     />
              //     <span>{params.row?.status?.name}</span>
              //   </div>
              // ),
            },
    {
      field: "Issues",
      headerName: "Issues",
      flex: 0.8,
      minWidth: 110,
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 140,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {

     


       
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
      
            <IconButton
              style={{ width: "30%" }}
              onClick={handleReviewDetailsModalShow}
              color="default"
              size="small"
              disableRipple
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

const rows=[{
id:"1",
date:"Dec 21, 2025 - 09:00 am",
Name:'Mallory Keaton',
status:'Passed',
Issues:"3 issues",
Action:""
}]

  const checkEquipmentColumns = [
    { field: "date", headerName: "Check Date", flex: 0.9, minWidth: 120 },
    {
      field: "Name",
      headerName: "Engineer Name",
      flex: 0.9,
      minWidth: 120,
      // renderCell: (params) => {
      //   const { name, imageUrl } = params.value;

      //   return (
      //     <div className="d-flex justify-content-center align-items-center h-100">
      //       <img
      //         src={imageUrl}
      //         alt={`${name} logo`}
      //         style={{
      //           width: 20,
      //           height: 20,
      //           objectFit: "cover",
      //         }}
      //       />
      //       <span className="ms-2">{name}</span>
      //     </div>
      //   );
      // },
    },
      {
              field: "status",
              headerName: "Status",
              flex: 0.9,
              minWidth: 120,
              // renderCell: (params) => (
              //   <div className="d-flex gap-2 align-items-center justify-content-center">
              //     <img
              //       src={
              //         params.row?.status?.image
              //           ? `${newImageUrl}${params.row.status.image}`
              //           : defaultImg
              //       }
              //       width={20}
              //     />
              //     <span>{params.row?.status?.name}</span>
              //   </div>
              // ),
            },
    {
      field: "Issues",
      headerName: "Issues",
      flex: 0.8,
      minWidth: 110,
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 140,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {

     


        const handleReview = (e) => {
          e.stopPropagation();
        };

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
      
            <IconButton
              style={{ width: "30%" }}
              onClick={handleReviewEquipmentCheckShow}
              color="default"
              size="small"
              disableRipple
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];

const checkEquipmentRows=[{
id:"1",
date:"Dec 21, 2025 - 09:00 am",
Name:'Mallory Keaton',
status:'Passed',
Issues:"3 issues",
Action:""
}]
  const CheckProductsColumns = [
    { field: "date", headerName: "Check Date", flex: 0.9, minWidth: 120 },
    {
      field: "Name",
      headerName: "Engineer Name",
      flex: 0.9,
      minWidth: 120,
      // renderCell: (params) => {
      //   const { name, imageUrl } = params.value;

      //   return (
      //     <div className="d-flex justify-content-center align-items-center h-100">
      //       <img
      //         src={imageUrl}
      //         alt={`${name} logo`}
      //         style={{
      //           width: 20,
      //           height: 20,
      //           objectFit: "cover",
      //         }}
      //       />
      //       <span className="ms-2">{name}</span>
      //     </div>
      //   );
      // },
    },
   
    {
      field: "Orders_Number",
      headerName: "Orders Number",
      flex: 0.8,
      minWidth: 110,
    },

    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 140,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {

     


        

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
      
            <IconButton
              style={{ width: "30%" }}
              onClick={handleReviewProductsCheckShow}
              color="default"
              size="small"
              disableRipple
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </div>
        );
      },
    },
  ];
const CheckProductsRows=[{
id:"1",
date:"Dec 21, 2025 - 09:00 am",
Name:'Mallory Keaton',
Orders_Number:'8 Orders',
Action:""
}]

   const [paginationModel, setPaginationModel] = useState({
                  page: 0,
                  pageSize: 10,
                });
const tabs = [
  { label: "Vehicle Check", content: <>
  
             <div className="my-4">
                          {/* {filteredRequests.length > 0 ? */}
                           <div className="data-grid-small">
                       
                            <Paper sx={{ height: "auto", width: "100%" }}>
                              <DataGrid
                                rows={rows}
                                columns={columns}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                checkboxSelection
                                sx={{  overflow: "hidden" }}
                                slotProps={{
                                  pagination: {
                                    sx: {
                                      justifyContent: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                  },
                                }}
                              />
                            </Paper>
                
                          </div> 
                          {/* : <div className="flex flex-column text-center">
                
                            <img src={noData} alt="no-data" />
                            <p style={{ color: "#535353" }} className=''>No available user requests</p>
                          </div>} */}
                
                
                
                        </div>
  </> },
  { label: "Equipment & Tools Check", content:  <>
  
             <div className="my-4">
                          {/* {filteredRequests.length > 0 ? */}
                           <div className="data-grid-small">
                       
                            <Paper sx={{ height: "auto", width: "100%" }}>
                              <DataGrid
                                rows={checkEquipmentRows}
                                columns={checkEquipmentColumns}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                checkboxSelection
                                sx={{  overflow: "hidden" }}
                                slotProps={{
                                  pagination: {
                                    sx: {
                                      justifyContent: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                  },
                                }}
                              />
                            </Paper>
                
                          </div> 
                          {/* : <div className="flex flex-column text-center">
                
                            <img src={noData} alt="no-data" />
                            <p style={{ color: "#535353" }} className=''>No available user requests</p>
                          </div>} */}
                
                
                
                        </div>
  </> },
  { label: "Products Check", content:  <>
  
             <div className="my-4">
                          {/* {filteredRequests.length > 0 ? */}
                           <div className="data-grid-small">
                       
                            <Paper sx={{ height: "auto", width: "100%" }}>
                              <DataGrid
                                rows={CheckProductsRows}
                                columns={CheckProductsColumns}
                                initialState={{ pagination: { paginationModel } }}
                                pageSizeOptions={[5, 10, 20, 50]}
                                checkboxSelection
                                sx={{  overflow: "hidden" }}
                                slotProps={{
                                  pagination: {
                                    sx: {
                                      justifyContent: "center",
                                      display: "flex",
                                      alignItems: "center",
                                    },
                                  },
                                }}
                              />
                            </Paper>
                
                          </div> 
                          {/* : <div className="flex flex-column text-center">
                
                            <img src={noData} alt="no-data" />
                            <p style={{ color: "#535353" }} className=''>No available user requests</p>
                          </div>} */}
                
                
                
                        </div>
  </> },
];
const [showReviewDetails, setShowReviewDetails] = useState(false)
    
     const handleReviewDetailsModalShow = () =>{
                setShowReviewDetails(true)
            }
     const handleReviewDetailsModalClose = () =>{
                setShowReviewDetails(false)
            }
const [showReviewEquipmentCheck, setShowReviewEquipmentCheck] = useState(false)
    
     const handleReviewEquipmentCheckShow = () =>{
                setShowReviewEquipmentCheck(true)
            }
     const handleReviewEquipmentCheckClose = () =>{
                setShowReviewEquipmentCheck(false)
            }
const [showReviewProductsCheck, setShowReviewProductsCheck] = useState(false)
    
     const handleReviewProductsCheckShow = () =>{
                setShowReviewProductsCheck(true)
            }
     const  handleReviewProductsCheckClose = () =>{
                setShowReviewProductsCheck(false)
            }
const [showViewRequestedProductsCheck, setShowViewRequestedProductsCheck] = useState(false)
    
     const handleViewRequestedProductsCheckShow = () =>{
                setShowReviewProductsCheck(false)
                setShowViewRequestedProductsCheck(true)
            }
     const  handleViewRequestedProductsCheckClose = () =>{
                setShowViewRequestedProductsCheck(false)
            }

  return (
     <>
        <Modal show={showReviewDetails} onHide={handleReviewDetailsModalClose} dialogClassName='custom-review-modal-size'>
                            <Modal.Header closeButton>
                                <Modal.Title className='m-0 w-100'>
                        <div className="d-flex justify-content-between align-items-center">
                                    <div className="">
                                       <h6 className="label-size main-text-color">Daily Checks Details</h6>
                                       <h6 className="fw-semibold">Dec 19, 2025 - 09:00 am</h6>
                                   
                  
                                  </div>
                     <div className="mx-3">
                            <div style={{ backgroundColor: "#ffffff" }} className="d-flex justify-content-center align-items-center gap-1 px-3 rounded-4">
                <div className='' style={{ width: "20px", height: "", }}>
                  <img
                    // src={requestDetails.status?.image ? `${newImageUrl}${requestDetails.status?.image}` : defaultImg}
                    src={passedIcon}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div
                  style={{
                    backgroundColor: "",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                  className='main-text-color'
                >
                  Partially passed
                  {/* {requestDetails.status?.name} */}
                </div>
              </div>
                     </div>
                             
                        </div>
        
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{direction:"rtl"}}>
                            <div className="my-3 px-2">
                                <div className="">
                                    <div style={{direction:"rtl"}} className="row">
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color">
                                      <p className="">سليم</p>
                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color">
                                      <p className="">عطل</p>
                                    </div>
                                  </div>
                                
                               </div>
                                  <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="">
 
      <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD"}} />

      }
      />
   

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="">
   <Checkbox
        // value={sub.id}
        icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}}  />}
        checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
      />                                    </div>
                                  </div>
                                  <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      الإطارات
                                    </h6>
                                  </div>
                                
                               </div>
                                     <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color dailyCheck-done ">
 
        <Checkbox
        // value={sub.id}
        
        icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}} />}
        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",}} />}
      />
   

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color dailyCheck-issue ">
   <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
      />                                    </div>
                                  </div>
                                    <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      الأنوار
                                    </h6>
                                  </div>
                               </div>
                                      <div className="my-3">
                              <div className="rounded-3 bg-light p-2">
                                <h6 className="main-text-color fw-semibold">ملاحظات</h6>
                                <p className="fw-semibold label-size">الأنوار مش شغالة كويس حسب نتيجة الفحص، والعربية محتاجة صيانة.</p>
                                <img src={ligthImage} alt="" />
                              </div>
                            </div>
                                     <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="">
 
      <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD"}} />

      }
      />
   

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="">
   <Checkbox
        // value={sub.id}
        icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}}  />}
        checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
      />                                    </div>
                                  </div>
                                  <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      الفرامل
                                    </h6>
                                  </div>
                                
                               </div>
                                          <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color dailyCheck-done ">
 
                                        <Checkbox
                                        // value={sub.id}
                                        
                                        icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}} />}
                                        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",}} />}
                                      />
   

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color dailyCheck-issue ">
                              <Checkbox
                                    // value={sub.id}
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
                                  />                                    </div>
                                  </div>
                                    <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      المرايات
                                    </h6>
                                  </div>
                               </div>
                                      <div className="my-3">
                              <div className="rounded-3 bg-light p-2">
                                <h6 className="main-text-color fw-semibold">ملاحظات</h6>
                                <p className="fw-semibold label-size">المرايات فيها مشكلة ومش بتدي رؤية واضحة للسواق.</p>
                                <div className="d-flex align-items-center gap-2">
                                  <img src={merrorImg1} alt="" />
                                  <img src={merrorImg2} alt="" />
                                </div>
                              </div>
                            </div>
                                <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="">
 
                                          <Checkbox
                                            // value={sub.id}
                                            checked
                                            icon={<CheckBoxOutlineBlankIcon />}
                                            checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD"}} />

                                          }
                                          />
                                        

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="">
                                    <Checkbox
                                          // value={sub.id}
                                          icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}}  />}
                                          checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
                                        />                                    </div>
                                  </div>
                                  <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      الزجاج / المساحات
                                    </h6>
                                  </div>
                                
                               </div>
                                </div>
                     
                       
                               
                            </div>
                     

                            </Modal.Body>
                            <Modal.Footer style={{backgroundColor:"#F8F8F8", direction:"rtl"}} className='d-block'>
                              <div className="d-flex justify-content-start">
                                 <div className="p-2 d-flex gap-3 align-items-center ">
                                  <h6 className="fw-semibold m-0">ملخص الفحص</h6>
                                  <p className="main-text-color label-size m-0">تم فحص 8 من 8 أجزاء: </p>
                                </div>
                              </div>
                               
                                <div className="d-flex gap-1 align-items-center">
                                       <div className="">
 
      <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD"}} />

      }
      />
   

                                    </div>
                                <h6 className="m-0">6  سليم</h6>
                                </div>
                                <div className="d-flex gap-1 align-items-center">
                                    <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
      />  
                                <h6 className="m-0">2  به عطل</h6>
                                </div>
                            </Modal.Footer>
                        </Modal>
                                <Modal show={showReviewEquipmentCheck} onHide={handleReviewEquipmentCheckClose} dialogClassName='custom-review-modal-size'>
                            <Modal.Header closeButton>
                                <Modal.Title className='m-0 w-100'>
                        <div className="d-flex justify-content-between align-items-center">
                                    <div className="">
                                       <h6 className="label-size main-text-color">Equipment & Tools Check Details</h6>
                                       <h6 className="fw-semibold">Dec 19, 2025 - 09:00 am</h6>
                                   
                  
                                  </div>
                     <div className="mx-3">
                            <div style={{ backgroundColor: "#ffffff" }} className="d-flex justify-content-center align-items-center gap-1 px-3 rounded-4">
                <div className='' style={{ width: "20px", height: "", }}>
                  <img
                    // src={requestDetails.status?.image ? `${newImageUrl}${requestDetails.status?.image}` : defaultImg}
                    src={passedIcon}
                    alt=""
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div
                  style={{
                    backgroundColor: "",
                    fontWeight: 600,
                    fontSize: "16px",
                  }}
                  className='main-text-color'
                >
                  Partially passed
                  {/* {requestDetails.status?.name} */}
                </div>
              </div>
                     </div>
                             
                        </div>
        
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{direction:"rtl"}}>
                            <div className="my-3 px-2">
                                <div className="">
                                    <div style={{direction:"rtl"}} className="row">
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color">
                                      <p className="">جاهز</p>
                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color">
                                      <p className="">غير جاهز</p>
                                    </div>
                                  </div>
                                
                               </div>
                                  <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="">
 
      <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD"}} />

      }
      />
   

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="">
   <Checkbox
        // value={sub.id}
        icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}}  />}
        checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
      />                                    </div>
                                  </div>
                                  <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      3 مفتاح عجل
                                    </h6>
                                  </div>
                                
                               </div>
                                     <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color dailyCheck-done ">
 
        <Checkbox
        // value={sub.id}
        
        icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}} />}
        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",}} />}
      />
   

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color dailyCheck-issue ">
   <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
      />                                    </div>
                                  </div>
                                    <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      مفتاح انجليزي
                                    </h6>
                                  </div>
                               </div>
                                      <div className="my-3">
                              <div className="rounded-3 bg-light p-2">
                                <h6 className="main-text-color fw-semibold">ملاحظات</h6>
                                <p className="fw-semibold label-size">المفتاح مفكوك و مش ثابت بيزحف على المسمار ومش بيمسك كويس.</p>
                                <img src={equipmentImg1} alt="" />
                              </div>
                            </div>
                                     <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="">
 
      <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD"}} />

      }
      />
   

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="">
   <Checkbox
        // value={sub.id}
        icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}}  />}
        checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
      />                                    </div>
                                  </div>
                                  <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      مفتاح سداسي
                                    </h6>
                                  </div>
                                
                               </div>
                                          <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color dailyCheck-done ">
 
                                        <Checkbox
                                        // value={sub.id}
                                        
                                        icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}} />}
                                        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",}} />}
                                      />
   

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="main-text-color dailyCheck-issue ">
                              <Checkbox
                                    // value={sub.id}
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
                                  />                                    </div>
                                  </div>
                                    <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      مضخة هواء يدوية
                                    </h6>
                                  </div>
                               </div>
                                      <div className="my-3">
                              <div className="rounded-3 bg-light p-2">
                                <h6 className="main-text-color fw-semibold">ملاحظات</h6>
                                <p className="fw-semibold label-size">الخرطوم مخروم أو متشقق الهواء بيهرب ومش بيزوّد الضغط.</p>
                                <div className="d-flex align-items-center gap-2">
                                  <img src={equipmentImg2} alt="" />
                                </div>
                              </div>
                            </div>
                                <div style={{direction:"rtl"}} className="row align-items-center">
                                  <div className="col-md-2 col-12">
                                    <div className="">
 
                                          <Checkbox
                                            // value={sub.id}
                                            checked
                                            icon={<CheckBoxOutlineBlankIcon />}
                                            checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD"}} />

                                          }
                                          />
                                        

                                    </div>
                                  </div>
                                  <div className="col-md-2 col-12">
                                    <div className="">
                                    <Checkbox
                                          // value={sub.id}
                                          icon={<CheckBoxOutlineBlankIcon sx={{color:"#535353"}}  />}
                                          checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
                                        />                                    </div>
                                  </div>
                                  <div className="col-md-8 col-12">
                                    <h6 className="m-0">
                                      الزجاج / المساحات
                                    </h6>
                                  </div>
                                
                               </div>
                                </div>
                     
                       
                               
                            </div>
                     

                            </Modal.Body>
                            <Modal.Footer style={{backgroundColor:"#F8F8F8", direction:"rtl"}} className='d-block'>
                              <div className="d-flex justify-content-start">
                                 <div className="p-2 d-flex gap-3 align-items-center ">
                                  <h6 className="fw-semibold m-0">ملخص الفحص</h6>
                                  <p className="main-text-color label-size m-0">تم فحص 26 من 26 اداه علي السياره: </p>
                                </div>
                              </div>
                               
                                <div className="d-flex gap-1 align-items-center">
                                       <div className="">
 
      <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD"}} />

      }
      />
   

                                    </div>
                                <h6 className="m-0">6  جاهز</h6>
                                </div>
                                <div className="d-flex gap-1 align-items-center">
                                    <Checkbox
        // value={sub.id}
        checked
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<DisabledByDefaultIcon sx={{color:"#A80101"}} />}
      />  
                                <h6 className="m-0">2 غير جاهز</h6>
                                </div>
                            </Modal.Footer>
                        </Modal>
                                <Modal show={showReviewProductsCheck} onHide={handleReviewProductsCheckClose} dialogClassName='custom-review-modal-size'>
                            <Modal.Header closeButton>
                                <Modal.Title className='m-0 w-100'>
                        <div className="d-flex justify-content-between align-items-center">
                                    <div className="">
                                       <h6 className="label-size main-text-color">Products Check Details</h6>
                                       <h6 className="fw-semibold">Dec 19, 2025 - 09:00 am</h6>
                                   
                  
                                  </div>
                  
                        </div>
        
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{direction:"rtl"}}>
                            <div className="my-3 px-2">
                              <div className="my-3">
                                <h6 className="main-text-color">
                                    تمت المراجعه
                                </h6>
                              </div>
                                <div className="">
                              
                                      <div className="accordion-item ">
                        <div className="accordion " id="accordionExample">
                            <h2 style={{ backgroundColor: "#F8F8F8CC", }} className="accordion-header  
                             accordion-header-responsive remove-border-focus d-flex px-2 rounded-3">
                                <img src={vehicleImg} alt="" />
                                <button style={{color:"#535353"}} className="accordion-button fix-accordion-dir fw-semibold bg-transparent" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    طلب <span className='fw-bold mx-1'> #ORD-3247</span>
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                <div className="accordion-body shadow-sm body-accordion-profile  rounded-2">
                                    <div className='my-3'>
                                       <div className="">
                                         <ul className='mx-4' style={{ listStyleType: "unset", color: "#535353",fontSize:"14px" }}>
                                            <li className='my-2'> اسم العميل:Mohamed Haroun</li>
                                            <li className='my-2'>الخدمات المطلوبه:</li>
                                        </ul>
                                       </div>
                                        <div className="d-flex align-items-center gap-1 w-100 my-1">
                                          <div className="">
                                            <img style={{width:"25px", }} className='' src={serviceImg} alt="" />

                                          </div>
                                          <div> 
                                          <h6 className="main-text-color label-size fw-semibold m-0">خدمه فحص الزيوت والفلاتر</h6></div>
                                        </div>
                                          <div className="d-flex align-items-center gap-1 w-100 my-1">
                                          <div className="">
                                            <img style={{width:"25px", }} className='' src={serviceImg} alt="" />

                                          </div>
                                          <div> 
                                          <h6 className="main-text-color label-size fw-semibold m-0">خدمه فحص الزيوت والفلاتر</h6></div>
                                        </div>
                                           <div className="">
                                         <ul className='mx-4' style={{ listStyleType: "unset", color: "#535353",fontSize:"14px" }}>
                                            <li className='my-2'>السعر الكلي: 4.400 ج.م</li>
                                            <li className='my-2'> العنوان: مدينة نصر، شارع الطيران، عمارة ١٨</li>
                                        </ul>
                                    <div style={{color:"#6881FF"}} className='my-2 text-decoration-underline '>https://www.google.com/maps?q=30.0444,31.2357</div>

                                       </div>
                                           <div className="">
                                         <ul className='mx-4' style={{ listStyleType: "unset", color: "#535353",fontSize:"14px" }}>
                                            <li className='my-2'>الوقت المتوقع: 1:30 مساءً</li>
                                            <li className='my-2 '>
                                             <div className="d-flex align-items-center gap-2">
                                               حالة الطلب:
                                              <div className="d-flex align-items-center gap-2">
                                                <img src={vehicleImg} alt="" />
                                                <p className="m-0 main-text-color">تم التعيين</p>
                                             </div>
                                                
                                              </div>
                                               </li>
                                        </ul>

                                       </div>
                                    </div>
                                    <div className="w-100">
                                        <button onClick={()=>handleViewRequestedProductsCheckShow()} className="btn btn-dark w-100">عرض فحص المواد المطلوبه</button>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                        
                                </div>
                     
                       
                               
                            </div>
                     

                            </Modal.Body>
                        
                        </Modal>
                                <Modal show={showViewRequestedProductsCheck} onHide={handleViewRequestedProductsCheckClose} dialogClassName='custom-review-modal-size'>
                            <Modal.Header closeButton>
                                <Modal.Title className='m-0 w-100'>
                        <div className="d-flex justify-content-between align-items-center">
                                    <div className="">
                                       <h6 className="label-size main-text-color">Products Check Details</h6>
                                       <h6 className="fw-semibold">Dec 19, 2025 - 09:00 am</h6>
                                   
                  
                                  </div>
                  
                        </div>
        
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{direction:"rtl"}}>
                            <div className="my-3 px-2">
                              
                               <div className="my-3 d-flex justify-content-between align-items-center">
                                  <div className="d-flex gap-2 align-items-center">
                                      <img src={vehicleImg} alt="" />
                                      <h6 className="m-0"> طلب <span className="fw-bold">#ORD-3247</span></h6>
                                  </div>
                                  <div className="">
                                    <h6 className="">تمت المراجعه</h6>
                                  </div>
                              </div>
                   <div className="">
                          <div className="d-flex align-items-center gap-1 w-100 my-2">
                                          <div style={{width:"25px",height:"25px", backgroundColor:"#FFFAEA" }} className="rounded-1 d-flex justify-content-center align-items-center">
                                            <img style={{width:"16px", height:"16px" }} className='' src={serviceImg} alt="" />

                                          </div>
                                          <div> 
                                          <h6 className="main-text-color fw-semibold m-0">خدمه فحص الزيوت والفلاتر</h6></div>
                                        </div>
                            <div className="d-flex align-items-center gap-1 w-100 my-3">
                                 <Checkbox
                                    sx={{width:"25px",height:"25px"}}      
                                    // value={sub.id}
                                    disableRipple
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",opacity:"60%"}} />

                                  }
                                  />
                  <h6 className="m-0">فلتر زيت Toyota Original #90915-YZZE1 — عدد 1</h6>
                            </div>
                            <div className="d-flex align-items-center gap-1 w-100 my-3">
                                 <Checkbox
                                    sx={{width:"25px",height:"25px"}}      
                                    // value={sub.id}
                                    disableRipple
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",opacity:"60%"}} />

                                  }
                                  />
                  <h6 className="m-0">فلتر هواء Toyota Genuine Air Filter #17801-0T020 — عدد 1</h6>
                            </div>
                            <div className="d-flex align-items-center gap-1 w-100 my-3">
                                 <Checkbox
                                    sx={{width:"25px",height:"25px"}}      
                                    // value={sub.id}
                                    disableRipple
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",opacity:"60%"}} />

                                  }
                                  />
                  <h6 className="m-0">زيت محرك Shell Helix 5W-30 — عدد 4 لتر</h6>
                            </div>
                   </div>
                               
                   <div className="my-3">
                          <div className="d-flex align-items-center gap-1 w-100 my-2">
                                          <div style={{width:"25px",height:"25px", backgroundColor:"#F8F8F8" }} className="rounded-1 d-flex justify-content-center align-items-center">
                                            <img style={{width:"16px", height:"16px" }} className='' src={serviceImg1} alt="" />

                                          </div>
                                          <div> 
                                          <h6 className="main-text-color fw-semibold m-0">خدمه فحص و كشف الكاوتش</h6></div>
                                        </div>
                            <div className="d-flex align-items-center gap-1 w-100 my-3">
                                 <Checkbox
                                    sx={{width:"25px",height:"25px"}}      
                                    // value={sub.id}
                                    disableRipple
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",opacity:"60%"}} />

                                  }
                                  />
                  <h6 className="m-0">مادة سد ثقوب Tire Sealant Liquid – 500ml</h6>
                            </div>
                            <div className="d-flex align-items-center gap-1 w-100 my-3">
                                 <Checkbox
                          
                                    sx={{width:"25px",height:"25px"}}      
                                    // value={sub.id}
                                    disableRipple
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",opacity:"60%"}} />

                                  }
                                  />
                  <h6 className="m-0">طقم لحام مطاط Rubber Plug Set – Small/Medium</h6>
                            </div>
                            <div className="d-flex align-items-center gap-1 w-100 my-3">
                                 <Checkbox
                                    sx={{width:"25px",height:"25px"}}      
                                    // value={sub.id}
                                    disableRipple
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",opacity:"60%"}} />

                                  }
                                  />
                  <h6 className="m-0">غاز نيتروجين للتعبئة — 2 أسطوانة صغيرة</h6>
                            </div>
                   </div>
                   <div className="my-3">
                          <div className="d-flex align-items-center gap-1 w-100 my-2">
                                          <div style={{width:"25px",height:"25px", backgroundColor:"#FFF4F0" }} className="rounded-1 d-flex justify-content-center align-items-center">
                                            <img style={{width:"16px", height:"16px" }} className='' src={serviceImg2} alt="" />

                                          </div>
                                          <div> 
                                          <h6 className="main-text-color fw-semibold m-0">خدمه فحص البطاريه </h6></div>
                                        </div>
                            <div className="d-flex align-items-center gap-1 w-100 my-3">
                                 <Checkbox
                                    sx={{width:"25px",height:"25px"}}      
                                    // value={sub.id}
                                    disableRipple
                                
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",opacity:"60%"}} />

                                  }
                                  />
                  <h6 className="m-0">بطارية ACDelco 55D23L – 12V — عدد 1 </h6>
                            </div>
                            <div className="my-3">
                                   <div className="rounded-3 bg-light p-2">
                                <h6 className="main-text-color fw-semibold">ملاحظات</h6>
                                <p className="fw-semibold label-size">البطاريه مش متاحه ف المخزن . هشتريها وانا ف الطريق للعميل</p>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-1 w-100 my-3">
                                 <Checkbox
                          
                                    sx={{width:"25px",height:"25px"}}      
                                    // value={sub.id}
                                    disableRipple
                                    checked
                                    icon={<CheckBoxOutlineBlankIcon />}
                                    checkedIcon={<CheckBoxIcon sx={{color:"#3BBFAD",opacity:"60%"}} />

                                  }
                                  />
                  <h6 className="m-0">أقطاب بطارية Battery Terminals Set – Positive/Negative — عدد 1</h6>
                            </div>
                           
                   </div>
                               
                            </div>
                     

                            </Modal.Body>
                        
                        </Modal>
        <div className="col-md-12 min-vh-100">
          <div
            className=" p-3 my-3 col-md-12 rounded-2 "
            style={{ border: "2px solid #EAEAEA " }}
          > 
          <div className="d-flex justify-content-between align-items-center">
         <div className="">
               <h6 className='m-0'>Daily Checks</h6>
         </div>
         <div className="d-flex gap-2 align-items-center w-50">
                   <input
                              type="date"
                              className="date-input form-control w-100"
                              value={filterDate}
                              onChange={(e) => {
                                setFilterDate(e.target.value);
                                // setPage(0);
                              }}
                            />
                
                            {filterDate && (
                              <button
                                type="button"
                                className="btn btn-sm btn-light position-absolute"
                                style={{
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  padding: "2px 6px",
                                  fontSize: "12px",
                                }}
                                onClick={() => {
                                  setFilterDate("");
                                  // setPage(0);
                                }}
                              >
                                ✕
                              </button>
                            )
                            }
                                <div className=''>  
                                    <div className="btn btn-light">
                                      <Tune
                                      style={{ cursor: "pointer" }}
                                      onClick={(e) => setAnchorEl(e.currentTarget)}
                                    />
                                    </div>
                                    
                                    <Menu
                                    className='my-2'
                                      anchorEl={anchorEl}
                                      open={open}
                                      onClose={() => setAnchorEl(null)}
                                      // sx={{width:"200px",padding:"15px",border:"1px solid red "}}
                                      PaperProps={{
                                        sx: {
                                          p: 1,       
                                          minWidth: 150,
                                          backgroundColor:"#F9F9F9" ,
                                          borderRadius:"10px"
                                          
                                        }
                                      }}
                                    >
                                      {statuses.map((item) => (
                                       <div className="">
                                         <MenuItem
                                          key={item.value}
                                          onClick={() => {
                                            console.log(item.value); 
                                            setAnchorEl(null);
                                          }}
                                          
                                        >
                                          <div className="p-2 d-flex gap-3 align-items-center">
                                            <img src={item.icon} alt="" />
                                            <div className="label-size m-0">{item.title}</div>
                                          </div>
                                        </MenuItem>
                                       </div>
                                      ))}
                                    </Menu>
                                    
                                    
                                              
                                              </div>
         </div>
          </div>
      <Box className='custom-tab-style' sx={{ marginBlock: 2, borderColor: 'divider' }}>
<Tabs
  value={tab}
  
  onChange={(e, v) => setTab(v)}
  sx={{ borderBottom:" 1px solid #D8D8D8",}}
  TabIndicatorProps={{
    sx: {
      backgroundColor: "#3FBEAC",
      height: "3px",


    
    },
  }}
  
  // sx={{
  //   "& .MuiTabs-flexContainer": {
  //     display: "inline-flex",
  //     gap: "12px",
  //   },

  //   "& .MuiTab-root": {
  //     textTransform: "none",
  //     minHeight: "40px",
  //     padding: "6px 16px",
  //     color: "#696969",
  //     fontWeight: 500,
  //     backgroundColor: "transparent",
  //   },

  //   "& .MuiTab-root.Mui-selected": {
  //     color: "#000000",
  //     backgroundColor: "transparent",
  //   },

  //   "& .MuiTab-root:hover": {
  //     backgroundColor: "transparent",
  //   },
  // }}
>
  {tabs.map((t, i) => (
    <Tab
      key={i}
      label={t.label}
        sx={{
    textTransform: "capitalize",
  }}
     
    />
  ))}
</Tabs>


      {/* <Tabs             sx={{
              "& .MuiTabs-flexContainer": {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                width: "fit-content",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                borderRadius: "10px",
                minHeight: "40px",
                color: "#696969",
                fontWeight: 500,
                transition: "all 0.3s ease",

              },
              "& .MuiTab-root.Mui-selected": {
                backgroundColor: "transparent",
                color: "#000000",
                // borderBottom:"1px solid #3FBEAC"
              },
              "& .MuiTabs-indicator.css-1qltlow-MuiTabs-indicator":{
                color:"#3FBEAC"
              }
            }} value={tab} onChange={(e, v) => setTab(v)}>
        {tabs.map((t, i) => (
          <Tab key={i} label={t.label} />
        ))}
      </Tabs> */}

      <Box>
        {tabs[tab].content}
      </Box>
    </Box>
            </div>
          </div>
     </>
  )
}

export default DailyCheckVanProfile